export const REDACTION_MATCH_PREVIEW_WIDTH = 253;
